import React, { useState } from 'react'
import CollapsibleSection from '../../../Components/CollapsibleSection.js'
import { WidgetEmbedTitles, WidgetTitleModalButton, WidgetTitles } from '../../Create/WidgetOptionsOptions.js'
import { WIDGET_TYPES } from '../../types'

const TitleSettings = ({ setFieldValue, values, widget, isMobile, setIsMobile, setModalOpenType }) => {
  const [openCollapsible, setOpenCollapsible] = useState()

  // FLOATING
  if (widget.type === WIDGET_TYPES.FLOATING) {
    return null // Floating widget doesn't have title sections
  }

  // SINGLE EMBED
  if (widget.type === WIDGET_TYPES.SINGLE_EMBED) {
    return (
      <>
        <WidgetTitleModalButton
          setFieldValue={setFieldValue}
          values={values}
          isMobile={isMobile}
          setIsMobile={setIsMobile}
          setModalOpenType={setModalOpenType}
        />
        <CollapsibleSection
          label="Embed Title"
          openCollapsible={openCollapsible}
          setOpenCollapsible={setOpenCollapsible}
          icon="text-white"
          noContentPadding
        >
          <WidgetEmbedTitles setFieldValue={setFieldValue} values={values} />
        </CollapsibleSection>
      </>
    )
  }

  // All other widget types have both Embed Title and Content Titles
  return (
    <>
      <CollapsibleSection
        label="Content Titles"
        startsOpen
        openCollapsible={openCollapsible}
        setOpenCollapsible={setOpenCollapsible}
        icon="text-white"
        noContentPadding
      >
        <WidgetTitles
          isMobile={isMobile}
          setIsMobile={setIsMobile}
          setFieldValue={setFieldValue}
          values={values}
          setModalOpenType={setModalOpenType}
        />
      </CollapsibleSection>
      <CollapsibleSection
        label="Embed Title"
        openCollapsible={openCollapsible}
        setOpenCollapsible={setOpenCollapsible}
        icon="text-white"
        noContentPadding
      >
        <WidgetEmbedTitles setFieldValue={setFieldValue} values={values} />
      </CollapsibleSection>
    </>
  )
}

export default TitleSettings
